/*
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-04 16:29:01
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-16 11:06:17
 * @FilePath: \zhucai_user\src\api\home.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/util/request";

export function Course_GetList(params) {
  return request({
    url: "/pc/Course/Course_GetList",
    method: "get",
    params,
  });
}
export function Enroll_GetList(params) {
  return request({
    url: "/pc/Enroll/Enroll_GetList",
    method: "get",
    params,
  });
}
export function Material_GetList(params) {
  return request({
    url: "/pc/Material/Material_GetList",
    method: "get",
    params,
  });
}
export function Exercise_GetList(params) {
  return request({
    url: "/pc/QBank/Exercise_GetList",
    method: "get",
    params,
  });
}
export function Course_GetTeachers(params) {
  return request({
    url: "/pc/QBank/Course_GetTeachers",
    method: "get",
    params,
  });
}
export function Course_GetRelatedCourses(params) {
  return request({
    url: "/pc/QBank/Course_GetRelatedCourses",
    method: "get",
    params,
  });
}

export function Column_GetList(params) {
  return request({
    url: "/pc/Course/Column_GetList",
    method: "get",
    params,
  });
}
